import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { TeamUser } from "../types/teams.types";

import { teamsQueryKeys } from "./queryKeyFactory";

type UseTeamAccountUsersQueryParams = {
    enabled?: boolean;
};

export const useTeamAccountUsersQuery = ({ enabled = true }: UseTeamAccountUsersQueryParams = {}) => {
    return useQuery<TeamUser[]>({
        queryKey: teamsQueryKeys.accountUsers(),
        queryFn: () => salesApiService.teams.fetchAccountUsers(),
        enabled,
    });
};
